<script type="text/javascript">
  export default {
    props: ['website'],
    data() {
      return {
        video: false,
        demo: 1,

        buttons: [
          {color: 'blue', title: "I'm Buying", active: false},
          {color: 'indigo', title: "Selling and Buying", active: false},
          {color: 'yellow', title: "Black Road", active: false},
          {color: 'purple', title: "Not Sure", active: false},
          {color: 'pink', title: "The Brown", active: false},
          {color: 'red', title: "Dog Ran", active: false},
          {color: 'orange', title: "Across The", active: false},
          {color: 'green', title: "To Catch The", active: false},
          {color: 'teal', title: "I'm Selling", active: false},
          {color: 'cyan', title: "I'm Buying", active: false},
          {color: 'warning', title: "Not Sure", active: false},
          {color: 'success', title: "The Brown", active: false},
          {color: 'info', title: "Dog Ran", active: false},
          {color: 'danger', title: "Across The", active: false},
          {color: 'dark', title: "I'm Selling", active: false},
        ],

        offices: [
          {
            title: 'Scottsdale, AZ Office',
            description: `At HUNT Real Estate ERA, our goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. Our commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. We are dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market`,
            image: 'https://revinre.coryallen.app/storage/fm/revinre-nc/Scottsdale.jpg',
            url: 'https://scottsdale.huntrealestateaz.com',
            address: '7308 E. Deer Valley, Suite 100',
            city: 'Scottsdale',
            state: 'AZ',
            zip_code: '85255',
            phone: '4804273500',
            email: '',
            agents: [
              {
                name: 'Clark Rowley',
                email: 'clark.rowley@revinre.com',
                phone: '(602) 999-8090',
                titles: 'Administrative Assistant, Licensed Real Estate Salesperson',
                about: `At HUNT Real Estate ERA, my goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. My commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. I am dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
                real_estate_number: 'SA047458000',
                headshot: 'https://content.mediastg.net/dynamic/RealEstate/company/699/account/669827/669827_04222022233648.jpg',
                url: 'https://clarkrowley.huntrealestateaz.com/',
              },
            ],
          },
          {
            title: 'Glendale, AZ Office',
            description: `At HUNT Real Estate ERA, our goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. Our commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. We are dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            image: 'https://revinre.coryallen.app/storage/fm/revinre-nc/Glendale.jpg',
            url: 'https://glendale.huntrealestateaz.com',
            address: '7170 W. Camino San Xavier, Suite D113',
            city: 'Glendale',
            state: 'AZ',
            zip_code: '85308',
            phone: '6233221171',
            email: '',
          },
          {
            title: 'Mesa, AZ Office',
            description: `At HUNT Real Estate ERA, our goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. Our commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. We are dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            image: 'https://revinre.coryallen.app/storage/fm/revinre-nc/Mesa.png',
            url: 'https://mesa.huntrealestateaz.com',
            address: '2500 S Power Rd Ste 122',
            city: 'Mesa',
            state: 'AZ',
            zip_code: '85209',
            phone: '4804273500',
            email: '',
          },
          {
            title: 'Gilbert, AZ Office',
            description: `At HUNT Real Estate ERA, our goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. Our commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. We are dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            image: 'https://revinre.coryallen.app/storage/fm/revinre-nc/Gilbert.png',
            url: 'https://gilbert.huntrealestateaz.com',
            address: '2500 S. Power Road, Building 9 - Suite 122',
            city: 'Mesa',
            state: 'AZ',
            zip_code: '85209',
            phone: '4804273500',
            email: '',
          },
          {
            title: 'Prescott, AZ Office',
            description: `At HUNT Real Estate ERA, our goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. Our commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. We are dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            image: 'https://revinre.coryallen.app/storage/fm/revinre-nc/prescott.png',
            url: 'https://prescott.huntrealestateaz.com',
            address: '635 N Old Coach Trail',
            city: 'Dewey-Humboldt',
            state: 'AZ',
            zip_code: '86327',
            phone: '4804273500',
            email: '',
          },
          {
            title: 'Charlotte, NC Office',
            description: `At HUNT Real Estate ERA, our goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. Our commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. We are dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            image: 'https://revinre.coryallen.app/storage/fm/revinre-nc/NC.png',
            url: 'https://charlotte.huntrealestateaz.com',
            address: 'Somewhere',
            city: 'Charlotte',
            state: 'NC',
            zip_code: '55555',
            phone: '5555555555',
            email: '',
          },
          {
            title: 'Depew, NY Office',
            description: `At HUNT Real Estate ERA, our goal is to be there for you throughout the entire real estate process, ensuring it is as easy and stress-free as possible. Our commitment is to deliver superior customer service backed by the industry’s most sophisticated real estate technology tools and marketing systems. We are dedicated to providing and interpreting accurate, in-depth information on home values and the real estate market.`,
            image: 'https://revinre.coryallen.app/storage/fm/revinre-nc/depew.png',
            url: 'https://depew.huntrealestateaz.com',
            address: '432 Dick Rd #200',
            city: 'Depew',
            state: 'NY',
            zip_code: '14043',
            phone: '7166265700',
            email: '',
          },
        ],
      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="1"
    ></w-site-navbar>
    <main>

      <section class="">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://revinre.coryallen.app/storage/fm/revinre-nc/backgrounds/35.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-13 pb-12 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-7">
              <div class="text-center mb-4">
                <h1 class="mb-3 text-white" data-aos="fade-zoom-in">Office Locations</h1>
                <p class="text-white"  data-aos="fade-zoom-in">A list of REVINRE office locations</p>
              </div>
            </div>
          </div>
        </div>
        <div class="position-absolute _pos-l-0 _pos-b-0 _pos-r-0 text-center">
          <ul class="list-inline">
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Facebook"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:facebook-fill" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Twitter"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:twitter-line" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Instagram"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:instagram-line" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on YouTube"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:youtube-line" height="20"></Icon></a></li>
          </ul>
        </div>
      </section>


      <section class="bg-gray-100">
        <div class="container-fluid py-5">
          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:building-4-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3">REVINRE Offices</h2>
            <p class="text-pre-wrap">Below you will find a list of our office locations along with our agents associated with each.</p>
          </div>
          <div class="row">
            <div v-for="(office, office_i) in offices" :key="office_i" class="col-sm-12 mb-4">
              <div class="card overflow-hidden">
                <div class="row m-0">
                  <div class="col-sm-4 p-0">
                    <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+formatImage(office.image)+');'"></div>
                    <!-- <img :src="office.image" class="w-100"> -->
                  </div>
                  <div class="col-sm-8 p-5">
                    <h3 class="mb-3">{{ office.title }}</h3>
                    <!-- {{ office.description }} -->
                    <div class="row mx-0 mb-2">
                      <div class="_w-15"><Icon icon="ri:road-map-line" height="20" class="text-black" /></div>
                      <div class="col">{{ office.address }}<br>{{ office.city }} {{ office.state }} {{ office.zip_code }}</div>
                    </div>
                    <div class="row mx-0 mb-5">
                      <div class="_w-15"><Icon icon="ri:phone-line" height="20" class="text-black" /></div>
                      <div class="col">{{ formatPhone(office.phone) }}</div>
                    </div>
                    <a :href="office.url" target="_blank" class="btn btn-revinre mr-3"><Icon icon="ri:external-link-line" /> View Branch Page</a>
                    <a :href="office.url" target="_blank" class="btn btn-revinre"><Icon icon="ri:external-link-line" /> View Branch Agents</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section class="bg-dark py-5"></section>


      <section class="bg-gray-100">
        <div class="container-fluid py-5">
          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:building-4-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3">REVINRE Offices</h2>
            <p class="text-pre-wrap">Below you will find a list of our office locations along with our agents associated with each.</p>
          </div>
          <div class="row">
            <div v-for="(office, office_i) in offices" :key="office_i" class="col-sm-6 mb-4">
              <div class="card overflow-hidden">
                <div class="row m-0">
                  <div class="col-sm-5 p-0">
                    <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+formatImage(office.image)+');'"></div>
                    <!-- <img :src="office.image" class="w-100"> -->
                  </div>
                  <div class="col-sm-7 p-4">
                    <h3 class="mb-3">{{ office.title }}</h3>
                    <!-- {{ office.description }} -->
                    <div class="row mx-0 mb-2">
                      <div class="_w-15"><Icon icon="ri:road-map-line" height="20" class="text-black" /></div>
                      <div class="col">{{ office.address }}<br>{{ office.city }} {{ office.state }} {{ office.zip_code }}</div>
                    </div>
                    <div class="row mx-0 mb-4">
                      <div class="_w-15"><Icon icon="ri:phone-line" height="20" class="text-black" /></div>
                      <div class="col">{{ formatPhone(office.phone) }}</div>
                    </div>
                    <a :href="office.url" target="_blank" class="btn btn-revinre mr-3"><Icon icon="ri:external-link-line" /> Branch Page</a>
                    <a :href="office.url" target="_blank" class="btn btn-revinre"><Icon icon="ri:external-link-line" /> Branch Agents</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section class="bg-dark py-5"></section>


      <section class="bg-gray-100">
        <div class="container-fluid py-5">
          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:building-4-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3">REVINRE Offices</h2>
            <p class="text-pre-wrap">Below you will find a list of our office locations along with our agents associated with each.</p>
          </div>
          <div class="row">
            <div v-for="(office, office_i) in offices" :key="office_i" class="col-sm-6 mb-4">
              <div class="card">
                <div class="card-header">
                  {{ office.title }}
                </div>
                <div class="card-body">
                  <div class="_w-250 _h-160 overflow-hidden float-left mr-3"><img :src="office.image"></div>
                  
                  <div class="row mx-0 mb-2">
                    <div class="_w-15"><Icon icon="ri:road-map-line" height="20" class="text-black" /></div>
                    <div class="col">{{ office.address }}<br>{{ office.city }} {{ office.state }} {{ office.zip_code }}</div>
                  </div>
                  <div class="row mx-0 mb-5">
                    <div class="_w-15"><Icon icon="ri:phone-line" height="20" class="text-black" /></div>
                    <div class="col">{{ formatPhone(office.phone) }}</div>
                  </div>
                  <a :href="office.url" target="_blank" class="btn btn-revinre mr-3"><Icon icon="ri:external-link-line" /> View Branch Page</a>
                  <a :href="office.url" target="_blank" class="btn btn-revinre"><Icon icon="ri:external-link-line" /> View Branch Agents</a>
                </div>
                <div class="card-footer">
                  <a :href="office.url" target="_blank">{{ office.title }} Website</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section class="bg-dark py-5"></section>


      <section class="bg-gray-100">
        <div class="container-fluid py-5">
          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:building-4-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3">REVINRE Offices</h2>
            <p class="text-pre-wrap">Below you will find a list of our office locations along with our agents associated with each.</p>
          </div>
          <div class="row justify-content-center">
            <div class="col-sm-4">
              <div id="accordion">
                <div v-for="(office, office_i) in offices" :key="office_i" class="card">
                  <div class="card-header p-0 border-light" :class="office_i == 0 ? '' : 'border-top'" :id="'heading'+office_i">
                    <div class="p-3 _c-pointer" data-toggle="collapse" :data-target="'#collapse'+office_i">
                      <h2 class="h4 m-0">{{ office.title }}</h2>
                    </div>
                  </div>
                  <div :id="'collapse'+office_i" class="collapse" :class="office_i == 0 ? 'show' : ''" data-parent="#accordion">
                    <div class="card-body">
                      <img :src="office.image" class="float-left mr-3 w-50">
                      {{ office.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="">
                <img src="https://revinre.coryallen.app/storage/fm/revinre-nc/map_3.png">
              </div>
            </div>
          </div>
        </div>
      </section>
      

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>

<style>
.temp_hover_icon:hover .iconify, .temp_hover_icon:hover h6, .temp_hover_icon.on .iconify, .temp_hover_icon.on h6 {
  color: white !important;
}
</style>